import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { WALLET_ADDRESS, NETWORK_SWITCH } from "./actions/types";
import { GetChainIndex } from "./Hooks/useWeb3";

const HelperRoute = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    setwalletStatus();
    setNetworkVal();
  }, []);

  const setwalletStatus = () => {
    try {
      if (sessionStorage.getItem("accountInfo")) {
        dispatch({
          type: WALLET_ADDRESS,
          payload: sessionStorage.getItem("accountInfo"),
        });
      }
    } catch (err) {
      console.log(err, "setwalletStatus__err");
    }
  };
  const setNetworkVal = () => {
    try {
      dispatch({
        type: NETWORK_SWITCH,
        payload: GetChainIndex(),
      });
      localStorage.setItem("CHAIN", GetChainIndex());
    } catch (err) {
      console.log(err, "setNetworkVal__err");
    }
  };
};

export default HelperRoute;
